// extracted by mini-css-extract-plugin
export default {"card_container":"OurIndustryCard_card_container__0phUc"};